import { Avatar, Paper, PaperProps, styled, Typography } from "@mui/material";
import { CustomGraph } from "components/result/resultGraphs/CustomGraph";
import { useTranslation } from "react-i18next";
import { ThemeScore } from "types/types";

interface Props extends PaperProps {
  themeScores: ThemeScore[];
}

export function ThemeGraphs(props: Props) {
  const { themeScores, ...paperProps } = props;
  const { t } = useTranslation();
  return (
    <StyledPaper {...paperProps}>
      <Typography variant="h2" component="h2">
        {t("label.byTheme")}
      </Typography>
      <Paper className="theme-graphs" elevation={0}>
        {themeScores.map((themeScore) => (
          <Paper
            className="theme-graph"
            elevation={0}
            key={themeScore.theme.id}
          >
            <Typography
              component="div"
              variant="h3-black"
              className="theme-title"
            >
              <Avatar src={themeScore.theme.iconUrl} variant="square" />
              {themeScore.theme.name}
            </Typography>
            <CustomGraph score={themeScore.score} />
          </Paper>
        ))}
      </Paper>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  .theme-graphs {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .theme-graph {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(6)};
    .theme-title {
      display: inline-flex;
      gap: ${({ theme }) => theme.spacing(1)};
      align-items: center;
      .MuiAvatar-img {
        width: 20px;
        height: 20px;
      }
    }
  }

  @media print {
    padding-left: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
  }
`;
